import { render, staticRenderFns } from "./40pgxmjys.vue?vue&type=template&id=45dc7024&"
import script from "./40pgxmjys.vue?vue&type=script&lang=js&"
export * from "./40pgxmjys.vue?vue&type=script&lang=js&"
import style0 from "./40pgxmjys.vue?vue&type=style&index=0&id=45dc7024&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports